"use client";

import { useLanguage } from "@/contexts/LanguageContext";

export default function SectionValue() {
  const { t } = useLanguage();

  const phases = [
    {
      title: "Foundation",
      tech: "Terraform + Vault",
      desc: t("sectionValue.phases.0.desc"),
      color: "text-purple-400",
      bg: "bg-purple-500/10",
      border: "border-purple-500/20",
    },
    {
      title: "Delivery",
      tech: "ArgoCD + GitHub Actions",
      desc: t("sectionValue.phases.1.desc"),
      color: "text-blue-400",
      bg: "bg-blue-500/10",
      border: "border-blue-500/20",
    },
    {
      title: "Runtime",
      tech: "K8s + Helm",
      desc: t("sectionValue.phases.2.desc"),
      color: "text-green-400",
      bg: "bg-green-500/10",
      border: "border-green-500/20",
    },
    {
      title: "Visibility",
      tech: "Grafana + Prometheus",
      desc: t("sectionValue.phases.3.desc"),
      color: "text-orange-400",
      bg: "bg-orange-500/10",
      border: "border-orange-500/20",
    },
  ];

  return (
    <section
      id="beneficios"
      className="bg-surface py-32 md:py-48 px-6 md:px-12 text-text-primary overflow-hidden relative min-h-[80vh] flex flex-col justify-center"
    >
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20 space-y-6">
          <span className="inline-block py-1 px-3 rounded-full bg-border-default text-text-muted text-sm font-mono tracking-wider mb-4 border border-border-hover">
            {t("sectionValue.badge")}
          </span>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-text-primary leading-tight">
            {t("sectionValue.title")}{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-brand-secondary">
              {t("sectionValue.titleHighlight")}
            </span>
          </h2>
          <p className="text-text-secondary text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            {t("sectionValue.subtitle.before")}{" "}
            <span className="text-text-primary font-bold">
              {t("sectionValue.subtitle.emphasis")}
            </span>{" "}
            {t("sectionValue.subtitle.after")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {phases.map((phase, i) => (
            <div
              key={phase.title}
              className={`group relative p-6 rounded-2xl bg-surface-card border ${phase.border} hover:bg-surface-elevated transition-all duration-300`}
            >
              <div className="mb-4">
                <span
                  className={`text-xs font-bold uppercase tracking-widest ${phase.color}`}
                >
                  {t("sectionValue.phase")} {i + 1}
                </span>
              </div>
              <h3 className="text-2xl font-bold mb-2 text-text-primary group-hover:text-text-primary transition-colors">
                {phase.title}
              </h3>
              <div className="text-sm font-mono text-text-secondary mb-4 bg-border-default py-1 px-2 rounded w-fit">
                {phase.tech}
              </div>
              <p className="text-text-secondary leading-relaxed text-sm">
                {phase.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Why CloudOps Section - Added based on request */}
        <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-12 border-t border-border-default pt-16">
          <div className="space-y-4">
            <h4 className="text-xl font-bold text-text-primary">
              {t("sectionValue.whyCloudOps.0.title")}
            </h4>
            <p className="text-text-secondary text-sm leading-relaxed">
              {t("sectionValue.whyCloudOps.0.desc")}
            </p>
          </div>
          <div className="space-y-4">
            <h4 className="text-xl font-bold text-text-primary">
              {t("sectionValue.whyCloudOps.1.title")}
            </h4>
            <p className="text-text-secondary text-sm leading-relaxed">
              {t("sectionValue.whyCloudOps.1.desc")}
            </p>
          </div>
          <div className="space-y-4">
            <h4 className="text-xl font-bold text-text-primary">
              {t("sectionValue.whyCloudOps.2.title")}
            </h4>
            <p className="text-text-secondary text-sm leading-relaxed">
              {t("sectionValue.whyCloudOps.2.desc")}
            </p>
          </div>
        </div>
      </div>

      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-brand-primary opacity-10 blur-[120px] rounded-full pointer-events-none" />
    </section>
  );
}
